import React, { memo } from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";
import CreateIcon from "@mui/icons-material/Create";

import { palette } from "../../theme/palette";
import { SHIFT_MANAGER_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING } from "../../consts/strings";

import { addNotification } from "../../reducers/ownApp";
import { setSelectedShiftManager } from "../../reducers/ownApp";

import { editShiftManager } from "../../reducers/shiftManagerManagement/thunkActions";

import { View } from "../View";
import { ShiftManagerCardContent } from "./ShiftManagerCardContent";
import { ShiftManagerLabel } from "./ShiftManagerLabel";

const useStyles = makeStyles(() => {
  return {
    shiftManager: {
      display: "flex",
      flexDirection: "column",
      background: palette.typography.white.neutral,
      padding: "0.625rem",
      paddingBottom: "0.5rem",
      cursor: "default",
      height: (props) => (props.height || 1) - 1,
    },
    highlighted: {
      background: palette.typography.white.disabled,
    },
    editIconBase: {
      backgroundColor: (props) =>
        props.editing
          ? palette.orange
          : props.notInWave
          ? "#30303044"
          : "#303030",
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    editIcon: {
      color: palette.typography.white.solid,
      width: "13px",
      height: "13px",
      cursor: "pointer",
    },
    top: {
      display: "flex",
      flexDirection: "row",
      gap: "0.5rem",
      marginRight: "0.25rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    bottom: {
      display: "flex",
      flexDirection: "row",
      gap: "0.3rem",
    },
    leftButtons: {
      width: "2.5rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginRight: "auto",
    },
    right: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      marginLeft: "0.5rem",
      color: "white",
      lineHeight: "1.25rem",
      gap: "0.25rem",
    },
    header: {
      height: "1.25rem",
      color: "white",
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
});

export const ShiftManagerCardBase = ({
  height,
  shiftManager,
  editMode,
  inEdit,
  selected,
}) => {
  const dispatch = useDispatch();
  const styles = useStyles({ editing: inEdit, height });

  const handleClick = (e) => {
    e.preventDefault();
    if (editMode)
      dispatch(
        addNotification({
          message:
            SHIFT_MANAGER_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING(shiftManager),
          options: { variant: "info" },
        })
      );
    else if (selected) dispatch(setSelectedShiftManager(null));
    else dispatch(setSelectedShiftManager(shiftManager));
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (editMode && !inEdit)
      dispatch(
        addNotification({
          message:
            SHIFT_MANAGER_MANAGEMENT_EDIT_MODE_ACTIVE_WARNING(shiftManager),
          options: { variant: "info" },
        })
      );
    else if (!editMode) dispatch(editShiftManager(shiftManager));
  };

  return (
    <div style={{ height }}>
      <View
        className={clsx(
          styles.shiftManager,
          (inEdit || selected) && styles.highlighted
        )}
        onClick={handleClick}
      >
        <View className={styles.top}>
          <ShiftManagerLabel shiftManager={shiftManager} />
          <View className={styles.header}>{shiftManager.shiftManagerName}</View>
        </View>
        <View className={styles.bottom}>
          <View className={styles.leftButtons}>
            <View className={styles.editIconBase} onClick={handleEdit}>
              <CreateIcon fontSize={"small"} className={styles.editIcon} />
            </View>
          </View>

          <ShiftManagerCardContent shiftManager={shiftManager} />
        </View>
      </View>
    </div>
  );
};

export default memo(ShiftManagerCardBase);
